import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Phone } from "@phosphor-icons/react";

export default function LegalLayout({ title, eyebrow, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-white text-[var(--text-primary)]" data-testid="legal-page">
      <header className="border-b border-[var(--border)] px-8 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <Logo size={36} />
        </Link>
        <nav className="flex gap-6 text-[13px] font-medium text-[var(--text-secondary)]">
          <Link to="/legal/terms" className="hover:text-[var(--text-primary)]">Terms</Link>
          <Link to="/legal/privacy" className="hover:text-[var(--text-primary)]">Privacy</Link>
          <Link to="/legal/aup" className="hover:text-[var(--text-primary)]">Acceptable Use</Link>
          <Link to="/legal/compliance" className="hover:text-[var(--text-primary)]">Telecom Compliance</Link>
          <Link to="/legal/cookies" className="hover:text-[var(--text-primary)]">Cookies</Link>
        </nav>
      </header>

      <article className="max-w-[820px] mx-auto px-8 py-16">
        {eyebrow && <div className="font-mono text-[11px] tracking-widest text-[var(--accent)] mb-3">/ {eyebrow}</div>}
        <h1 className="font-display font-black text-[48px] leading-[1.0]">{title}</h1>
        {lastUpdated && <p className="font-mono text-[12px] text-[var(--text-muted)] mt-3 tracking-widest">LAST UPDATED · {lastUpdated}</p>}
        <div className="prose prose-slate max-w-none mt-10 text-[15px] leading-relaxed [&_h2]:font-display [&_h2]:font-bold [&_h2]:text-[24px] [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:font-semibold [&_h3]:text-[18px] [&_h3]:mt-7 [&_h3]:mb-2 [&_p]:mb-4 [&_p]:text-[var(--text-secondary)] [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_ul]:text-[var(--text-secondary)] [&_li]:mb-1 [&_strong]:text-[var(--text-primary)] [&_a]:text-[var(--accent)] [&_a]:font-semibold">
          {children}
        </div>
        <div className="border-t border-[var(--border)] mt-16 pt-6 flex items-center justify-between text-[12px] text-[var(--text-muted)]">
          <Link to="/" className="hover:text-[var(--text-primary)]">← Back to home</Link>
          <span className="font-mono tracking-widest">© 2026 HELLO BY FLOW</span>
        </div>
      </article>
    </div>
  );
}
